type Props = {
  children: React.ReactNode;
};

export default function ThemeRtlLayout({ children }: Props) {
  // removed because "stylisPlugins" is breaking the build after adding sourcemaps
  return <>{children}</>;
}